<template>
  <b-tooltip
    v-if="text"
    :label="text"
    :position="position"
    :triggers="triggers"
    :append-to-body="appendToBody"
    :delay="300"
    type="is-dark"
    size="is-large"
    multilined
    class="resdps-help-tip"
  >
    <b-icon
      icon="information-outline"
      size="is-small"
      class="has-text-grey"
      role="img"
      tabindex="0"
      :aria-label="text"
    />
  </b-tooltip>
</template>

<script>
export default {
  name: "ResdpsHelpTip",
  props: {
    text: {
      type: String,
      default: "",
    },
    position: {
      type: String,
      default: "is-top",
    },
    // Pentru containerele care taie continutul (antetul tab-urilor, tabelele).
    appendToBody: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // click pentru ecranele tactile, unde nu exista hover
      triggers: ["hover", "click"],
    };
  },
};
</script>

<style scoped>
.resdps-help-tip {
  margin-left: 0.25rem;
  vertical-align: middle;
  cursor: help;
}
</style>
